import { graphql } from 'src/graphql';

export const AskablePlusAudienceConfig = graphql(`
  fragment AskablePlusAudienceConfig on ProjectAskablePlusAudience @_unmask {
    description
    booking_config {
      participant_category
      timezone
      location {
        country
        city
        region
        state
        latitude
        longitude
        name
      }
      incentive {
        currency_code
        currency_symbol
        country_code
        value
      }
      session {
        duration
        time_limit
      }
      online_task {
        links {
          _id
          name
          url
          checked
        }
        type
        tool
        required_device
        required_features
      }
      remote {
        tool
        askable_live
      }
      question {
        _id
        title
        description
        options {
          _id
          label
          screen_in
        }
        config {
          display_participant
          multiple_selection
          none_of_the_above
          type
        }
      }
      criteria {
        meta_identity_birthday_year {
          field
          value
          operator
        }
        meta_identity_gender {
          field
          value
          operator
        }
        meta_family_status {
          field
          value
          operator
        }
        meta_education {
          field
          value
          operator
        }
        meta_work_status {
          field
          value
          operator
        }
        meta_work_employment_type {
          field
          value
          operator
        }
        meta_work_industry {
          _industry_id
          industry_name
          subcategories {
            _subcategory_id
            subcategory_name
          }
        }
        meta_identity_languages_english_speak {
          field
          value
          operator
        }
        meta_identity_locales {
          field
          value
          operator
          locale
        }
        meta_identity_languages {
          field
          value
          operator
        }
        meta_education_field {
          field
          value
          operator
        }
        meta_individual_income {
          field
          value
          operator
        }
        meta_family_income {
          field
          value
          operator
        }
        meta_tech_savviness {
          field
          value
          operator
        }
        meta_home_ownership {
          field
          value
          operator
        }
        meta_purchasing_behaviour {
          field
          value
          operator
        }
        meta_children {
          field
          value
          operator
        }
        custom {
          _question_id
          value
          operator
        }
        filters_order
        exclude_participants_from_time
        locations {
          states {
            name
            state
            formatted_address
            latitude
            longitude
            google_location_types
            google_location {
              viewport {
                northeast {
                  lat
                  lng
                }
                southwest {
                  lat
                  lng
                }
              }
            }
          }
          bounds {
            formatted_address
            state
            latitude
            longitude
            google_location_types
            google_location {
              geometry {
                latitude_ne
                longitude_ne
                latitude_sw
                longitude_sw
              }
              viewport {
                northeast {
                  lat
                  lng
                }
                southwest {
                  lat
                  lng
                }
              }
            }
          }
          countries {
            name
            state
            formatted_address
            latitude
            longitude
            google_location_types
            google_location {
              viewport {
                northeast {
                  lat
                  lng
                }
                southwest {
                  lat
                  lng
                }
              }
            }
          }
        }
      }
    }
  }
`);
